import { Create } from "react-admin";
import { useNotification } from "../../../common/hooks/useNotification";
import { EditActions } from "../../common/form/FormActions";
import { MobileAppVersionForm } from "./MobileAppVersionForm";

interface Props {}

export const MobileAppVersionCreate = (props: Props) => {
  const notify = useNotification(props, "createSuccess");
  return (
    <Create
      {...props}
      actions={<EditActions />}
      onSuccess={notify}
      title="Add a new mobile app version"
    >
      <MobileAppVersionForm />
    </Create>
  );
};
